module.exports = __webpack_public_path__ + "img/k2@2x.ac3afe0e.png";